module.exports = __webpack_public_path__ + "img/04_full.9876dc99.jpg";